module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('BaseWidget', [_c('template', {
    slot: "title"
  }, [_c('i', {
    staticClass: "fas fa-star fa-1x pointer",
    style: ({
      color: _vm.colors.color4
    })
  }), _vm._v(" " + _vm._s(_vm.$t("dashboardModule.featureTitle")) + "\n    ")]), _vm._v(" "), _c('template', {
    slot: "content-desktop"
  }, [_c('div', {
    staticClass: "catalog-star-item"
  }, _vm._l((_vm.itemList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item-star"
    }, [_c('router-link', {
      attrs: {
        "to": '/' + item.type + '/' + item.id
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('figure', {
      staticClass: "col-md-4"
    }, [_c('img', {
      attrs: {
        "src": _vm.getImgPath(item.figures.small, 'small')
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_c('h4', {
      staticClass: "ff-medium uppercase"
    }, [_vm._v(_vm._s(item.terms.name[_vm.$t("trad")]["value"]))]), _vm._v(" "), (item.infosArticle.hasOwnProperty('client_ref1')) ? _c('p', [_vm._v("\n                                " + _vm._s(item.infosArticle.client_ref1.componentProperty.value) + "\n                            ")]) : _vm._e(), _vm._v(" "), (item.infosArticle.hasOwnProperty('diam_ref1')) ? _c('p', [_vm._v(_vm._s(item.infosArticle.diam_ref1.componentProperty.value))]) : _vm._e()])])])], 1)
  }))]), _vm._v(" "), _c('template', {
    slot: "content-mobile"
  }, [_c('div', {
    staticClass: "catalog-star-item"
  }, _vm._l((_vm.itemList), function(item) {
    return _c('div', {
      key: item.id,
      staticClass: "item-star"
    }, [_c('router-link', {
      attrs: {
        "to": '/' + item.type + '/' + item.id
      }
    }, [_c('div', {
      staticClass: "row"
    }, [_c('figure', {
      staticClass: "col-md-4"
    }, [_c('img', {
      attrs: {
        "src": _vm.getImgPath(item.figures.small, 'small')
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-md-8"
    }, [_c('h4', {
      staticClass: "ff-medium uppercase"
    }, [_vm._v(_vm._s(item.terms.name[_vm.$t("trad")]["value"]))]), _vm._v(" "), (item.infosArticle.hasOwnProperty('client_ref1')) ? _c('p', [_vm._v("\n                                " + _vm._s(item.infosArticle.client_ref1.componentProperty.value) + "\n                            ")]) : _vm._e(), _vm._v(" "), (item.infosArticle.hasOwnProperty('diam_ref1')) ? _c('p', [_vm._v(_vm._s(item.infosArticle.diam_ref1.componentProperty.value))]) : _vm._e()])])])], 1)
  }))]), _vm._v(" "), _c('template', {
    slot: "footer"
  }, [_c('LinkButton', {
    attrs: {
      "to": '/catalog?star=1',
      "text": _vm.$t('dashboardModule.seeAllCat')
    }
  })], 1)], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5e6c4e2a","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/widgets/StarredItemsWidget.vue
// module id = 3215
// module chunks = 0